import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UPDATE_ROUTES } from './../store/stateReducer';

@Component({
  selector: 'app-next-step',
  templateUrl: './next-step.component.html',
  styleUrls: ['./next-step.component.scss']
})
export class NextStepComponent implements OnInit {

  private state: any;

  constructor( private store: Store<any>, private router: Router ) {
    this.store
      .select(state => state.stateReducer)
      .subscribe(state => this.state = state);
  }

  ngOnInit() {
    for (const key in this.state.routes) {
      if (this.state.routes[key]) {
        this.state.routes[key] = false;
        this.updateRoutes();
        this.router.navigate([ key ]);
        break;
      }
      this.router.navigate([ 'overview' ]);
    }
  }

  private updateRoutes() {
    this.store.dispatch({type: UPDATE_ROUTES, payload: this.state.routes});
  }

}



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/next-step/next-step.component.ts